import { reactive } from "vue";
export default reactive({
    self: this,
    csport: '4',
    c: {},
    sbetsc: 0,
    bala: {},
    balsm: {},
    rinfo1: {},
    rinfo2: {},
    pbets1: {},
    pbets: {},
    pbetsev: {},
    pbetsev1: {},
    stbets: {},
    stbetsall: {},
    stbetsall2: {},
    stbetsall3: {},
    allbooks: {},
    bkuwevents1: {},
    bkuwusers1: {},
    i: false,
    cn: false,
    balc: false,
    A1d: "",
    A2d: "",
    A3d: "",
    A4d: "",
    A5d: "",
    A6d: "",
    A7d: "",
    A8d: "",
    A9d: "",
    A10d: "",
    A1: 0,
    A2: 0,
    A3: 0,
    A4: 0,
    A5: 0,
    A6: 0,
    A7: 0,
    A8: 0,
    A9: 0,
    A10: 0,
    cricv: 0,
    socv: 0,
    tenv: 0,
    horv: 0,
    grev: 0,
    lastsettledid: 0,
    lastfancyid: 0,
    bkdc: 0,
    cbetsc: 0,
    pbetsall: 0,
    pbets1all: 0,
    stbetsall1: 0,
    cricd: reactive([]),
    socd: reactive([]),
    tend: reactive([]),
    hord: reactive([]),
    gred: reactive([]),
    cbets: reactive([]),
    sbets: reactive([]),
    cricdc: 1,
    socdc: 1,
    tendc: 1,
    hordc: 1,
    greydc: 1,
    homeopt: 4,
    sd: {},
    bettoplace: {},
    ismobile: false,
    betcount: 0,
    rules: '',
    currentsports: '4',
    clientdata:{
        ip: "",
        ipdone: false,
        ip6: "",
        ip6done: false,
        ip1: "",
        ip1done: false,
        device: "",
        devicedone: false,
        ua: "",
        uadone: false,
        fingerprint: "",
        fingerprintdone: false,
        country: "",
        countrydone: "",
        ao: [],
        error: ""
    },
    newbooks:{

    },
    message: "All Sports, Unlimited Live &amp; Virtual Casino, Fantasy Games &amp; Unlimited Slot Games On Very Popular, Simple, Safest &amp; Fastest Exchange.",
    marketanaly: {}
});